var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _g2, _path, _g3, _path2, _g4, _circle, _circle2, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlackNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 95,
    viewBox: "0 0 118 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_937_16709)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9102 17.9989C24.0944 17.8345 24.2114 17.6077 24.2384 17.3622C24.2654 17.1167 24.2007 16.8699 24.0566 16.6693C23.9125 16.4687 23.6993 16.3286 23.458 16.2758C23.2168 16.223 22.9645 16.2614 22.7499 16.3836V15.7489C22.7496 15.5459 22.6876 15.3477 22.572 15.1808C22.4565 15.0139 22.2928 14.8861 22.1029 14.8144C21.9129 14.7427 21.7057 14.7306 21.5086 14.7795C21.3116 14.8285 21.1341 14.9363 20.9999 15.0886C20.8354 14.9043 20.6086 14.7874 20.3632 14.7603C20.1177 14.7333 19.8709 14.7981 19.6703 14.9421C19.4697 15.0862 19.3295 15.2994 19.2768 15.5407C19.224 15.782 19.2624 16.0342 19.3845 16.2489H18.7499C18.5468 16.2491 18.3487 16.3111 18.1818 16.4267C18.0148 16.5423 17.887 16.7059 17.8154 16.8958C17.7437 17.0858 17.7315 17.2931 17.7805 17.4901C17.8295 17.6871 17.9373 17.8646 18.0895 17.9989C17.9053 18.1633 17.7883 18.3901 17.7613 18.6356C17.7343 18.8811 17.799 19.1279 17.9431 19.3284C18.0872 19.529 18.3004 19.6692 18.5417 19.722C18.7829 19.7747 19.0352 19.7363 19.2499 19.6142V20.2489C19.2501 20.4519 19.3121 20.65 19.4277 20.817C19.5432 20.9839 19.7069 21.1117 19.8968 21.1834C20.0868 21.255 20.294 21.2672 20.4911 21.2182C20.6881 21.1692 20.8656 21.0615 20.9999 20.9092C21.1643 21.0935 21.3911 21.2104 21.6366 21.2374C21.882 21.2644 22.1288 21.1997 22.3294 21.0556C22.53 20.9115 22.6702 20.6983 22.7229 20.457C22.7757 20.2158 22.7373 19.9635 22.6152 19.7489H23.2499C23.4529 19.7486 23.651 19.6866 23.8179 19.5711C23.9849 19.4555 24.1127 19.2919 24.1843 19.1019C24.256 18.9119 24.2682 18.7047 24.2192 18.5076C24.1702 18.3106 24.0624 18.1332 23.9102 17.9989ZM19.2499 18.7489C19.2499 18.8478 19.2205 18.9444 19.1656 19.0267C19.1106 19.1089 19.0326 19.173 18.9412 19.2108C18.8498 19.2487 18.7493 19.2586 18.6523 19.2393C18.5553 19.22 18.4662 19.1724 18.3963 19.1024C18.3264 19.0325 18.2788 18.9434 18.2595 18.8464C18.2402 18.7494 18.2501 18.6489 18.2879 18.5575C18.3258 18.4662 18.3898 18.3881 18.4721 18.3331C18.5543 18.2782 18.651 18.2489 18.7499 18.2489H19.2499V18.7489ZM20.7499 20.2489C20.7499 20.3815 20.6972 20.5087 20.6034 20.6024C20.5096 20.6962 20.3825 20.7489 20.2499 20.7489C20.1172 20.7489 19.9901 20.6962 19.8963 20.6024C19.8025 20.5087 19.7499 20.3815 19.7499 20.2489V18.7489C19.7499 18.6163 19.8025 18.4891 19.8963 18.3953C19.9901 18.3016 20.1172 18.2489 20.2499 18.2489H20.7499V20.2489ZM20.7499 17.7489H18.7499C18.6172 17.7489 18.4901 17.6962 18.3963 17.6024C18.3025 17.5087 18.2499 17.3815 18.2499 17.2489C18.2499 17.1163 18.3025 16.9891 18.3963 16.8953C18.4901 16.8016 18.6172 16.7489 18.7499 16.7489H20.2499C20.3825 16.7489 20.5096 16.8016 20.6034 16.8953C20.6972 16.9891 20.7499 17.1163 20.7499 17.2489V17.7489ZM20.7499 16.2489H20.2499C20.151 16.2489 20.0543 16.2196 19.9721 16.1646C19.8898 16.1097 19.8258 16.0316 19.7879 15.9402C19.7501 15.8489 19.7402 15.7483 19.7595 15.6513C19.7788 15.5543 19.8264 15.4652 19.8963 15.3953C19.9662 15.3254 20.0553 15.2778 20.1523 15.2585C20.2493 15.2392 20.3498 15.2491 20.4412 15.2869C20.5326 15.3248 20.6106 15.3889 20.6656 15.4711C20.7205 15.5533 20.7499 15.65 20.7499 15.7489V16.2489ZM21.2499 15.7489C21.2499 15.6163 21.3025 15.4891 21.3963 15.3953C21.4901 15.3016 21.6172 15.2489 21.7499 15.2489C21.8825 15.2489 22.0096 15.3016 22.1034 15.3953C22.1972 15.4891 22.2499 15.6163 22.2499 15.7489V17.2489C22.2499 17.3815 22.1972 17.5087 22.1034 17.6024C22.0096 17.6962 21.8825 17.7489 21.7499 17.7489H21.2499V15.7489ZM21.7499 20.7489C21.6172 20.7489 21.4901 20.6962 21.3963 20.6024C21.3025 20.5087 21.2499 20.3815 21.2499 20.2489V19.7489H21.7499C21.8825 19.7489 22.0096 19.8016 22.1034 19.8953C22.1972 19.9891 22.2499 20.1163 22.2499 20.2489C22.2499 20.3815 22.1972 20.5087 22.1034 20.6024C22.0096 20.6962 21.8825 20.7489 21.7499 20.7489ZM23.2499 19.2489H21.7499C21.6172 19.2489 21.4901 19.1962 21.3963 19.1024C21.3025 19.0087 21.2499 18.8815 21.2499 18.7489V18.2489H23.2499C23.3825 18.2489 23.5096 18.3016 23.6034 18.3953C23.6972 18.4891 23.7499 18.6163 23.7499 18.7489C23.7499 18.8815 23.6972 19.0087 23.6034 19.1024C23.5096 19.1962 23.3825 19.2489 23.2499 19.2489ZM23.2499 17.7489H22.7499V17.2489C22.7499 17.15 22.7792 17.0533 22.8341 16.9711C22.8891 16.8889 22.9671 16.8248 23.0585 16.7869C23.1499 16.7491 23.2504 16.7392 23.3474 16.7585C23.4444 16.7778 23.5335 16.8254 23.6034 16.8953C23.6733 16.9652 23.721 17.0543 23.7402 17.1513C23.7595 17.2483 23.7496 17.3489 23.7118 17.4402C23.6739 17.5316 23.6099 17.6097 23.5276 17.6646C23.4454 17.7196 23.3487 17.7489 23.2499 17.7489Z",
    fill: "#FFF4F0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_937_16709)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 66,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 72,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_937_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 56.375L59.375 56.375L59.375 55L58.625 55ZM58.625 57.2917L58.625 60.0417L59.375 60.0417L59.375 57.2917L58.625 57.2917ZM58.625 60.9583L58.625 63.7083L59.375 63.7083L59.375 60.9583L58.625 60.9583ZM58.625 64.625L58.625 66L59.375 66L59.375 64.625L58.625 64.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 66.2652C58.8813 66.4116 59.1187 66.4116 59.2652 66.2652L61.6517 63.8787C61.7981 63.7322 61.7981 63.4948 61.6517 63.3483C61.5052 63.2019 61.2678 63.2019 61.1213 63.3483L59 65.4697L56.8787 63.3483C56.7322 63.2019 56.4948 63.2019 56.3484 63.3483C56.2019 63.4948 56.2019 63.7322 56.3484 63.8787L58.7348 66.2652ZM58.625 55L58.625 57.2917L59.375 57.2917L59.375 55L58.625 55ZM58.625 58.2083L58.625 62.7917L59.375 62.7917L59.375 58.2083L58.625 58.2083ZM58.625 63.7083L58.625 66L59.375 66L59.375 63.7083L58.625 63.7083Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_937_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 38",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "5 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_937_16709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 46.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 46.75,
    r: 6.75,
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_937_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8997 42.875C57.6809 42.875 57.4711 42.962 57.3164 43.1168C57.1618 43.2715 57.0749 43.4814 57.0749 43.7002C57.075 43.919 57.162 44.1288 57.3167 44.2835C57.4715 44.4382 57.6813 44.525 57.9001 44.525H58.7251V43.7C58.7249 43.4813 58.6379 43.2715 58.4833 43.1169C58.3286 42.9622 58.1189 42.8752 57.9001 42.875M57.9001 45.0751H55.7C55.4812 45.0751 55.2714 45.162 55.1166 45.3168C54.9619 45.4715 54.875 45.6813 54.875 45.9001C54.875 46.1189 54.9619 46.3288 55.1166 46.4835C55.2714 46.6382 55.4812 46.7251 55.7 46.7251H57.8997C58.1186 46.7251 58.3284 46.6382 58.4831 46.4835C58.6378 46.3288 58.7248 46.1189 58.7248 45.9001C58.7248 45.6813 58.6378 45.4715 58.4831 45.3168C58.3284 45.162 58.1186 45.0751 57.8997 45.0751M63.125 45.8997C63.125 45.6809 63.0381 45.4711 62.8834 45.3164C62.7286 45.1617 62.5188 45.0747 62.3 45.0747C62.0812 45.0747 61.8714 45.1617 61.7166 45.3164C61.5619 45.4711 61.475 45.6809 61.475 45.8997V46.7248H62.3C62.5188 46.7248 62.7286 46.6378 62.8834 46.4831C63.0381 46.3284 63.125 46.1186 63.125 45.8997ZM60.9249 45.8997V43.7C60.9249 43.4812 60.838 43.2714 60.6832 43.1166C60.5285 42.9619 60.3187 42.875 60.0999 42.875C59.8811 42.875 59.6712 42.9619 59.5165 43.1166C59.3618 43.2714 59.2749 43.4812 59.2749 43.7V45.8997C59.2749 46.1186 59.3618 46.3284 59.5165 46.4831C59.6712 46.6378 59.8811 46.7248 60.0999 46.7248C60.3187 46.7248 60.5285 46.6378 60.6832 46.4831C60.838 46.3284 60.9249 46.1186 60.9249 45.8997ZM60.0999 51.125C60.3187 51.125 60.5285 51.0381 60.6832 50.8834C60.838 50.7286 60.9249 50.5188 60.9249 50.3C60.9249 50.0812 60.838 49.8714 60.6832 49.7166C60.5285 49.5619 60.3187 49.475 60.0999 49.475H59.2749V50.3C59.275 50.5188 59.3619 50.7286 59.5166 50.8833C59.6713 51.0379 59.8811 51.1249 60.0999 51.125ZM60.0999 48.9245H62.3C62.5188 48.9245 62.7286 48.8376 62.8834 48.6829C63.0381 48.5281 63.125 48.3183 63.125 48.0995C63.125 47.8807 63.0381 47.6709 62.8834 47.5161C62.7286 47.3614 62.5188 47.2745 62.3 47.2745H60.1003C59.8814 47.2745 59.6716 47.3613 59.5168 47.516C59.3621 47.6707 59.2751 47.8805 59.2751 48.0993C59.275 48.3181 59.3619 48.528 59.5166 48.6827C59.6712 48.8375 59.8811 48.9245 60.0999 48.9245ZM54.875 48.0999C54.875 48.3187 54.9619 48.5285 55.1166 48.6832C55.2714 48.838 55.4812 48.9249 55.7 48.9249C55.9188 48.9249 56.1286 48.838 56.2834 48.6832C56.4381 48.5285 56.525 48.3187 56.525 48.0999V47.2749H55.7C55.4812 47.2749 55.2714 47.3618 55.1166 47.5165C54.9619 47.6712 54.875 47.8811 54.875 48.0999ZM57.0751 48.0999V50.2996C57.0751 50.5184 57.1619 50.7283 57.3166 50.883C57.4713 51.0378 57.6811 51.1248 57.8999 51.1248C58.1187 51.1249 58.3286 51.038 58.4834 50.8833C58.6381 50.7286 58.7251 50.5188 58.7251 50.3V48.1003C58.7252 47.8814 58.6383 47.6716 58.4836 47.5168C58.3289 47.3621 58.1191 47.2751 57.9003 47.2751C57.6815 47.275 57.4716 47.3619 57.3169 47.5166C57.1621 47.6712 57.0752 47.8811 57.0751 48.0999Z",
    fill: "#394353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_937_16709",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_16709",
    result: "effect2_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_16709",
    result: "effect3_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_16709",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_937_16709",
    x: 0,
    y: 60,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_937_16709",
    result: "effect2_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_937_16709",
    result: "effect3_dropShadow_937_16709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_937_16709",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_937_16709",
    x: 48.2383,
    y: 47,
    width: 21.5234,
    height: 27.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_16709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_937_16709",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_937_16709"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_937_16709",
    x: 47.126,
    y: 35.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_937_16709"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_16709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_937_16709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(54.5 42.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackNode);
export default __webpack_public_path__ + "static/media/slackNode.89607f5e8ee23d61e980b0bb6183af56.svg";
export { ForwardRef as ReactComponent };